import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  ADD_WITHDRAW, BUMP_WITHDRAW, CANCEL_WITHDRAW,
  CONFIRM_WITHDRAW,
  LOAD_WITHDRAWS_LIST,
  RESET_WITHDRAWS,
  RESTART_WITHDRAW
} from "@/store/const/withdraws";

export default {
  namespaced: true,
  state: {
    withdraws: {
      list: [],
      pagination: {},
    },
    statuses: {
      checking: 'На проверке',
      wait: 'Ожидание',
      in_progress: 'Выполняется',
      review: 'Требует проверки',
      error: 'Ошибка',
      success: 'Выполнен',
      canceled: 'Отменен',
    },
  },
  getters: {
    withdraws: state => state.withdraws,
    statuses: state => state.statuses,
  },
  actions: {
    [LOAD_WITHDRAWS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_WITHDRAWS_LIST,
        namespace: 'withdraws',
        params,
      }, { root: true });
    },
    [ADD_WITHDRAW]: async ({ dispatch }, data) => {
      return await dispatch(HTTP_POST, {
        method: ADD_WITHDRAW,
        namespace: 'withdraws',
        no_commit: true,
        body: { data },
      }, { root: true });
    },
    [CONFIRM_WITHDRAW]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_PUT, {
        method: CONFIRM_WITHDRAW,
        namespace: 'withdraws',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
    [RESTART_WITHDRAW]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_PUT, {
        method: RESTART_WITHDRAW,
        namespace: 'withdraws',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
    [BUMP_WITHDRAW]: async ({ dispatch }, { id, params = {}, token_2fa }) => {
      return await dispatch(HTTP_PUT, {
        method: BUMP_WITHDRAW,
        namespace: 'withdraws',
        no_commit: true,
        params,
        body: { token_2fa },
        replace: { id },
      }, { root: true });
    },
    [CANCEL_WITHDRAW]: async ({ dispatch }, { id }) => {
      return await dispatch(HTTP_DELETE, {
        method: CANCEL_WITHDRAW,
        namespace: 'withdraws',
        no_commit: true,
        replace: { id },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_WITHDRAWS_LIST]: (state, { data }) => {
      Vue.set(state.withdraws, 'list', data.list);
      Vue.set(state.withdraws, 'pagination', data.pagination);
    },
    [RESET_WITHDRAWS]: (state) => {
      Vue.set(state, 'withdraws', { pagination: {}, list: []});
    }
  },
};
